


























































































import { computed, defineComponent, ref } from "@vue/composition-api";
import { VaultCategory, VaultFile } from "@scrile/api-provider/dist/api/VaultsProvider";
import emitter from "@/lib/emitter";
import { UploadVaultFile } from "@/types";
import { EVENTS } from "@/const";
import BaseDropZone from "@/components/BaseDropZone";
import BaseIconButton from "@/components/BaseIconButton";
import MediaFileAddButton from "@/components/MediaFileAddButton";
import PageTitle from "@/components/PageTitle";
import { acceptedFiles } from "../../const";
import { SortType } from "../../types";
import VaultDeleteFilesConfirm from "../VaultDeleteFilesConfirm";
import VaultFilesList from "../VaultFilesList";
import VaultMenu from "../VaultMenu";
import VaultMoveConfirm from "../VaultMoveConfirm";

export default defineComponent({
  name: "VaultManage",
  components: {
    PageTitle,
    VaultMenu,
    BaseDropZone,
    VaultFilesList,
    MediaFileAddButton,
    BaseIconButton,
    VaultDeleteFilesConfirm,
    VaultMoveConfirm,
  },
  props: {
    selectedCategory: { type: Object as () => VaultCategory, required: true },
    categories: { type: Array as () => VaultCategory[], required: true },
    files: { type: Array as () => VaultFile[], required: true },
    sortType: { type: String as () => SortType, required: true },
    filesLoading: { type: Boolean, default: false },
    fileScroll: { type: Boolean, default: false },
    categoryScroll: { type: Boolean, default: false },
    processing: { type: Boolean, default: false },
    uploadingFiles: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const manage = ref(false);
    const checkedFiles = ref<UploadVaultFile[]>([]);
    const showDeletedConfirm = ref(false);
    const showMoveFilesConfirm = ref(false);

    const allowUpload = computed(() => !props.selectedCategory.system);
    const categoryList = computed(() => props.categories.filter(c => c.id !== props.selectedCategory.id));
    const noCheckedFiles = computed(() => checkedFiles.value.length === 0);

    const onManage = (value: boolean) => {
      manage.value = value;
      emitter.emit(EVENTS.MAIN_MENU_HIDE, value);
    };

    const onBack = () => {
      if (manage.value) {
        checkedFiles.value = [];
        onManage(false);
        return;
      }
      emit("update:sort", SortType.LAST_USE_TIME_DESC);
      emit("selectCategoryId", "");
    };

    const resetState = () => {
      onManage(false);
      checkedFiles.value = [];
      showDeletedConfirm.value = false;
      showMoveFilesConfirm.value = false;
    };

    const onMoveFiles = (categoryId: string): void => {
      emit("move:files", { files: checkedFiles.value, categoryId }, resetState);
    };

    const onDeleteFiles = async () => {
      emit("delete:files", checkedFiles.value, resetState);
    };

    return {
      manage,
      categoryList,
      allowUpload,
      acceptedFiles,
      noCheckedFiles,
      showMoveFilesConfirm,
      showDeletedConfirm,
      checkedFiles,
      onMoveFiles,
      onDeleteFiles,
      onManage,
      onBack,
    };
  },
});
